import React from 'react';

export default function SortButton({ className='btn btn-sm btn-secondary', onClick, text, up }) {
    return <button className={className} onClick={onClick}>{text} <i style={{ fontSize: '0.8rem'}} className={up ? 'kt-menu__ver-arrow la la-angle-up' : 'kt-menu__ver-arrow la la-angle-down'}></i></button>
}